module.exports = __webpack_public_path__ + "img/27.2e5c81c1.jpg";